var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { Fragment } from 'react';
import styled from '@emotion/styled';
import css from '@emotion/css';
import { position, right, width, height, space, color, textAlign, fontSize, border, borderRadius, background, maxWidth, maxHeight, top, } from 'styled-system';
import { fill } from '../../theme/system-utilities';
import { isTouchDevice } from '../../DeviceDetector';
import Icon from '../Icon';
var ICON_SIZE = '24px';
var Button = styled.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  cursor: pointer;\n  font: inherit;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", "\n"], ["\n  cursor: pointer;\n  font: inherit;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ",
    "\n"])), background, borderRadius, color, border, textAlign, fontSize, space, maxWidth, function () {
    return isTouchDevice() && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      outline: none;\n    "], ["\n      outline: none;\n    "])));
});
Button.defaultProps = {
    borderRadius: 0,
    background: 'none',
    color: 'gray.16',
    fontSize: ['fs_16', 'fs_18', null, 'fs_20'],
    border: 'none',
    textAlign: 'left',
    p: 0,
    m: 0,
    maxWidth: '100%',
};
var Arrow = styled(Icon)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  transform: translateY(-50%) rotate(", "deg);\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  transform: translateY(-50%) rotate(", "deg);\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), function (props) { return (props.down ? 90 : -90); }, position, width, height, maxWidth, maxHeight, top, right, fill);
Arrow.defaultProps = {
    position: 'absolute',
    width: ICON_SIZE,
    maxWidth: ICON_SIZE,
    height: ICON_SIZE,
    maxHeight: ICON_SIZE,
    right: 0,
    top: '50%',
    fill: 'gray.9',
    role: 'presentation',
    name: 'arrowRight',
};
var AccordionSectionButton = function (_a) {
    var sectionName = _a.sectionName, sectionTitleId = _a.sectionTitleId, isExpanded = _a.isExpanded, children = _a.children;
    return (React.createElement(Fragment, null,
        React.createElement(Button, { "aria-expanded": isExpanded, "aria-controls": sectionName, id: sectionTitleId, "data-testid": "accordion-button" }, children),
        React.createElement(Arrow, { down: !isExpanded })));
};
export default AccordionSectionButton;
var templateObject_1, templateObject_2, templateObject_3;
